import { ChatPreview } from "../entities/chat";
import React from "react";

interface Props {
  data: ChatPreview;
  onClick?: () => void;
}

export const ChatOrderCard: React.FC<Props> = ({ data, onClick }) => {
  const time = new Date(data.lastMessageAt).toLocaleTimeString("ru-RU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      onClick={onClick}
      className="
        mt-2
        flex items-center gap-3
        rounded-2xl bg-white px-3 py-3
        shadow-sm
        relative
        cursor-pointer
        hover:bg-slate-50
      "
    >
      <div className="relative">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-white text-sm font-semibold">
          #{data.orderNumber}
        </div>

        {data.hasUnread && (
          <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-red-600" />
        )}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between">
          <p className="truncate text-sm font-semibold text-slate-900">
            {data.displayName}
          </p>
          <span className="ml-2 text-[11px] text-slate-400 whitespace-nowrap">
            {time}
          </span>
        </div>

        <div className="mt-1 flex items-center justify-between gap-2">
          <p
            className={`
              truncate text-xs
              ${data.hasUnread ? "font-semibold text-slate-900" : "text-slate-500"}
            `}
          >
            {data.lastMessage
              ? data.lastMessage.content
              : "Нет сообщений"}
          </p>

          {data.unreadCount > 0 && (
            <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-blue-600 px-1 text-[11px] font-semibold text-white">
              {data.unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
